import { useAuth } from '@/hooks/useAuth';

/**
 * Le rôle Lecteur ne peut rien écrire : le backend refuse toutes ses mutations
 * (`requireMinRole('MEMBER')`). L'écran doit s'y conformer.
 *
 * Sans ce garde-fou, un Lecteur voyait « + Devis / + Facture / + Dépense », ouvrait
 * le formulaire, le remplissait en entier, et ne se prenait le 403 qu'à l'envoi.
 */
export function useCanWrite(): boolean {
    const { user } = useAuth();
    return !!user && user.role !== 'VIEWER';
}

/**
 * Les exports qui sortent toute la comptabilité de l'entreprise en un fichier (FEC,
 * export CSV comptable, export RGPD) sont réservés au propriétaire et aux
 * administrateurs côté serveur : l'écran ne doit pas offrir un bouton qui rendra 403.
 *
 * Le rôle seul, sans le mode exemple : un export ne change rien à l'entreprise.
 */
export function useIsOwnerOrAdmin(): boolean {
    const { user } = useAuth();
    return user?.role === 'OWNER' || user?.role === 'ADMIN';
}
